<template>
  <div ref="timer__block" class="timer__block">
    <div class="timer__block__item timer--days">
      <div class="count">{{ days }}</div>
      <div class="text">{{ daysText }}</div>
    </div>
    <div class="timer__block__separator timer--days">&nbsp;:&nbsp;</div>
    <div class="timer__block__item timer--hours">
      <div class="count">{{ hours }}</div>
      <div class="text">{{ hoursText }}</div>
    </div>
    <div class="timer__block__separator timer--minutes">&nbsp;:&nbsp;</div>
    <div class="timer__block__item timer--minutes">
      <div class="count">{{ minutes }}</div>
      <div class="text">{{ minutesText }}</div>
    </div>
    <div class="timer__block__separator timer--seconds">&nbsp;:&nbsp;</div>
    <div class="timer__block__item timer--seconds">
      <div class="count">{{ seconds }}</div>
      <div class="text">{{ secondsText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Timer",
  props: {
    secondsLeft: Number,
    autoStart: Boolean,
    eventTime: Number,
    lang: String,
  },

  data() {
    return {
      currentSeconds: this.secondsLeft,
      start: Date.now(),
      interval: null,
      diff: null,
      stop_timer: false,
      cur_lang: this.lang || "ru",
      stop_emit: false,
      texts: {
        ru: {
          // one, two, five
          seconds: ["Секунда", "Секунды", "Секунд"],
          minutes: ["Минута", "Минуты", "Минут"],
          hours: ["Час", "Часа", "Часов"],
          days: ["День", "Дня", "Дней"],
        },
      },
    };
  },

  computed: {
    seconds() {
      return ("0" + (Math.floor(this.diff) % 60)).slice(-2);
    },
    minutes() {
      return ("0" + (Math.floor(this.diff / 60) % 60)).slice(-2);
    },
    hours() {
      return ("0" + (Math.floor(this.diff / 3600) % 24)).slice(-2);
    },
    days() {
      return ("" + Math.floor(this.diff / 86400)).slice(-2);
    },
    secondsText() {
      return this.declOfNum(this.seconds, this.texts[this.cur_lang].seconds);
    },
    minutesText() {
      return this.declOfNum(this.minutes, this.texts[this.cur_lang].minutes);
    },
    hoursText() {
      return this.declOfNum(this.hours, this.texts[this.cur_lang].hours);
    },
    daysText() {
      return this.declOfNum(this.days, this.texts[this.cur_lang].days);
    },
  },
  watch: {
    autoStart() {
      this.autoStartChecker();
    },
  },

  mounted() {
    this.autoStartChecker();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    timer() {
      this.diff = this.currentSeconds - (((Date.now() - this.start) / 1000) | 0);
      if (this.diff <= 60 && !this.stop_emit) {
        this.stop_emit = true;
        this.$emit("seconds");
      }
      if (this.diff <= 0) {
        this.stop_timer = true;
      }
      if (this.diff == this.eventTime - 1) {
        this.$emit("counterEventTime");
      }
    },
    autoStartChecker() {
      if (this.autoStart) {
        this.start = Date.now();
        this.startInterval();
      } else {
        this.timer();
      }
    },
    startInterval() {
      clearInterval(this.interval);
      this.timer();
      this.interval = setInterval(() => {
        if (!this.stop_timer) {
          this.timer();
        } else {
          this.$emit("counterEnd");
          clearInterval(this.interval);
        }
      }, 1000);
    },
    declOfNum(n, titles) {
      return titles[
        n % 10 === 1 && n % 100 !== 11
          ? 0
          : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
          ? 1
          : 2
      ];
    },
  },
};
</script>

<style lang="stylus">
.timer__block {
  &__item {
    display: inline-block;
  }

  &__separator {
    display: inline-block;
  }
}
</style>
